import { MobileCard } from '@/Components/shared/List/MobileCard';
import { ContractBadge } from './ContractBadge';
import { DisputeBadge } from './DisputeBadge';
import { formatPrice, formatDate, formatFullName, getContractDisplayPrice } from '../utils/contractFormatter';
import { SignatureStatusBadge } from '../utils/signatureStatus';
import type { ContractListItem } from '../types/contract.types';

interface ContractsMobileCardsProps {
  data: ContractListItem[];
  onRowClick?: (contract: ContractListItem) => void;
}

export function ContractsMobileCards({ data, onRowClick }: ContractsMobileCardsProps) {
  return (
    <div className="tw-space-y-3">
      {data.map((contract) => {
        const beneficiary = contract.beneficiary
          ? formatFullName(contract.beneficiary.firstName, contract.beneficiary.lastName)
          : '-';
        const registration = contract.vehicle?.registration || '-';

        return (
          <MobileCard
            key={contract.id}
            title={
              <div className="tw-flex tw-items-center tw-gap-2">
                <span>{contract.label}</span>
                {!!contract.isUpsell && (
                  <span className="tw-inline-flex tw-items-center tw-px-1.5 tw-py-0.5 tw-rounded tw-text-[10px] tw-font-bold tw-bg-indigo-100 tw-text-indigo-700">UpSell</span>
                )}
                {contract.assistanceFormulaId != null && (
                  <span className="tw-inline-flex tw-items-center tw-px-1.5 tw-py-0.5 tw-rounded tw-text-[10px] tw-font-bold tw-bg-teal-100 tw-text-teal-700">Assist</span>
                )}
              </div>
            }
            subtitle={contract.company?.name}
            status={
              <div className="tw-inline-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-1">
                <ContractBadge status={contract.idStatus} monthlyPaymentId={contract.monthlyPaymentId} monthlyPaymentStatus={contract.monthlyPaymentStatus} cancelationRequested={contract.cancelationRequested} cancelationRequestedAt={contract.cancelationRequestedAt} />
                {contract.latestDisputeStatus && <DisputeBadge status={contract.latestDisputeStatus} />}
              </div>
            }
            fields={[
              { label: 'Beneficiaire', value: beneficiary },
              { label: 'Immat.', value: registration },
              { label: 'Prix', value: (() => {
                const price = getContractDisplayPrice(contract);
                return (
                  <span className="tw-font-medium tw-text-green-600">
                    {price.kind === 'cash'
                      ? formatPrice(price.total)
                      : `${price.duration} × ${formatPrice(price.monthly)}`}
                  </span>
                );
              })() },
              { label: 'Duree', value: contract.duration ? `${contract.duration} mois` : '-' },
              { label: 'Cree le', value: formatDate(contract.dateCreation) },
              { label: 'Signature', value: <SignatureStatusBadge status={contract.signatureStatus ?? null} /> },
            ]}
            onClick={onRowClick ? () => onRowClick(contract) : undefined}
          />
        );
      })}
    </div>
  );
}
